export enum TargetType {
  value = 0,
  count = 1
}

export class TargetTypeHelper {
  static getLabel(targetType: TargetType): string {
    switch (targetType) {
      case TargetType.value:
        return 'value';
      case TargetType.count:
        return 'count of values';
    }
    return '';
  }
}